<template>
  <div class="index">
    <div style="float: right;
    padding-right: 20px;">
      <div  class="btnCancell"><span  @click="viewFeedbackBack()">我的反馈</span></div>
    </div>
    <van-cell>
      <div style="display:flex; align-items:center">
        <span style="color:red;">*</span>
        <span class="mr20" style="word-break:keep-all">意见类别</span>
      </div>
      <div style="margin-bottom: 5px;">
        <input type="text" readonly v-model="param.code" class="inputStyle" @click="showDept = true"
               placeholder="请选择">
      </div>
      <div class="radio" >
        <span style="color:red;">*</span><span>具体环节</span>
      </div>
      <div style="margin-bottom: 5px;">
        <label>
          <input type="input" name="specific"  value="输入具体环节" v-model="param.specific" maxlength="50"  class="inputStyle">
        </label><br/>
      </div>
      <div class="radio" >
        <span style="color:red;">*</span><span>联系方式</span>
      </div>
      <div style="margin-bottom: 5px;">
        <label>
          <input type="input" name="specific"  value="输入具体环节" v-model="param.phoneNo" maxlength="16"  class="inputStyle">
        </label><br/>
      </div>

      <div class="radio">
        <span style="color:red;">*</span><span>意见建议</span>
      </div>
      <div>
       <van-field  placeholder="" v-model="param.content" type="textarea" rows="3" autosize style="border: 1px solid grey;"></van-field>
      </div>
    </van-cell>
    <van-popup v-model="showDept" position="bottom">
      <van-picker value-key="code" :columns="deptList" title="请选择" @confirm="confirmPickerDept" @cancel="showDept = false"
                  show-toolbar />
    </van-popup>
    <div style="">
    <van-button  class="submit" @click="submit">
      <span>提交</span>
    </van-button>
   </div>
  </div>
</template>

<script>
import {commonAjax, commonAjaxJson, commonReq} from '../../common/js/api'
import { Col,Row,Field,Cell,CellGroup,RadioGroup,Radio,Button,Popup,Form,NoticeBar,Picker} from 'vant'
export default {
  async created() {
  },
  async mounted() {
    this.getDeptList();
    if(localStorage.encryptUserId){
      this.userId=localStorage.encryptUserId;
      localStorage.setItem("encryptUserId",this.userId);
    }else{
      let decode = decodeURIComponent(this.$route.query.encryptUserId);
      let id = encodeURIComponent(decode);
      this.userId=id;
      localStorage.setItem("encryptUserId",id)
    }
  },

  data() {
    return {
      showDept:false,
      showName:false,
      deptList:[],
      isDisabled:false,
      sexList:[
        {name:'女',id:'0'},
        {name:'男',id:'1'},
      ],
      param: {
        code:'',
        kinds:'',
        specific:'',
        phoneNo:'',
        content:''
      }
    }
  },

  methods: {
    confirmPickerDept(val, index) {
      this.param.code =  val.code;
      this.param.kinds = val.id;
      this.showDept = false;
    },
    getDeptList(){
      let res=[];
      res.push({"id":"4","code":"门诊服务"});
      res.push({"id":"5","code":"急诊服务"});
      res.push({"id":"6","code":"住院服务"});
      res.push({"id":"7","code":"医疗服务"});
      res.push({"id":"8","code":"医技服务"});
      res.push({"id":"9","code":"诊后服务"});
      res.push({"id":"10","code":"申请审批"});
      res.push({"id":"11","code":"综合服务"});
      res.push({"id":"12","code":"便民服务"});
      res.push({"id":"13","code":"信息支撑"});
      this.deptList = res;
    },
    submit(){

      if(!this.param.kinds){
        return this.$toast('请选择意见类型');
      }
      if(!this.param.specific){
        return this.$toast('请填写具体环节');
      }
      if(!this.param.phoneNo){
        return this.$toast('请填写联系方式');
      }
      if(!this.param.content){
        return this.$toast('请填写意见内容');
      }
      let utype =(this.$route.query.utype== 1 ? "患者版" : "员工版")
      commonAjaxJson(
          `/authex/advise/addV2`,
            {
            kinds:this.param.kinds,
            specific:this.param.specific,
            phoneNo:this.param.phoneNo,
            content:this.param.content,
            encryptUserId :this.userId,
            utype:utype
      },
          false,false,true
      ).then((res) => {
        console.info(res)
        this.$toast('提交成功')
        setTimeout(() => {
          this.$router.push({
            path: "/feedbackList",
            query: {
              encryptUserId: this.userId
            },
          });

        }, 1000);
      });


    },
    viewFeedbackBack(){
      this.$router.push({
        path: "/feedbackList",
        query: {
          encryptUserId: this.userId
        },
      });
    }
  },

  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [NoticeBar.name]: NoticeBar,
    [Picker.name]: Picker,
  },

  computed: {},
  watch: {
  }
}
</script>
<style lang="scss">
.van-picker__toolbar {
  height: 9.111vw;
}
.van-picker__title {
  line-height: 2;
}

.van-notice-bar__wrap {
  height: 5.333vw;
}

</style>

<style lang="scss" scoped>
/* 针对移动端的样式 */
@media (max-width: 768px) {
  body {
    background-color: #ffffff;
  }
  .index {
    padding: 10px;
    .pb15 {
      padding-bottom: 15px;
    }
    .pb20 {
      padding-bottom: 20px;
    }
    .mr90 {
      margin-right: 90px;
    }
    .radio{
      margin-bottom: 5px;
    }
    label{
      line-height: 4.5vh;
    }
    .labelMr{
      margin-right: 2vw;
    }
    .title{
      text-align: center;
    }
    .inputF{
      zoom: 150%;
      vertical-align: sub;
    }
    .inputStyle{
      height: 50px;
      width:100%;
      border:1px gray solid;
      border-radius: 10px;
    }
    .btnCancell{
      text-align: center;
      line-height: 60px;
      width: 120px;
      background-color: rgb(7, 193, 96);
      color: white;
      border: 1px solid;
    }
  }
}

/* 针对PC端的样式 */
@media (min-width: 769px) {
  .index {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    .pb15 {
      padding-bottom: 15px;
    }
    .pb20 {
      padding-bottom: 20px;
    }
    .mr90 {
      margin-right: 90px;
    }
    .radio{
      margin-bottom: 5px;
    }
    label{
      line-height: 4.5vh;
    }
    .labelMr{
      margin-right: 2vw;
    }
    .title{
      text-align: center;
    }
    .inputF{
      zoom: 150%;
      vertical-align: sub;
    }
    .inputStyle{
      height: 40px;
      width:100%;
      border:1px gray solid;
      border-radius: 10px;
    }
    .btnCancell{
      text-align: center;
      line-height: 60px;
      width: 120px;
      background-color: rgb(7, 193, 96);
      color: white;
      border: 1px solid;
    }
  }
}

.mr20 {
  padding-right: 20px;
}
.banner {
  display: block;
  height: auto;
  width: 660px;
  margin: 0 auto;
  // margin-top: 22px;
}

.submit {
  //position:fixed;
  bottom:0;
  // left: 4%;
  //width: 100%;
  //height: 90px;
  background: #00aac6;
  color: #fff;
  font-size: 18px;
  // margin: 0 auto;
  display: block;
  // margin-top: 24px;
  border-radius: 12px;
  margin-left: 20px;
  margin-right: 20px;
  width: 90%;
}
</style>
